module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAALCAIAAAD5gJpuAAAABGdBTUEAAK/INwWK6QAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAAAEOSURBVHjaYvzPgAD/UNlYEUAAmuTYAAAQhAEYqF/zFbe50RZ1cMmS9TLi0pJLRjZohAMTGFUN9HdnHgEE1sDw//+Tp0ClINW/f0NIKPoFJH/9//ULyGaUlQXaABBALGCz/6OoBkoDzYMoBan+DdHA8Ps3UANAALEAMSNQNVDFnz8Mv4EkFrPhGoCmAwQQCwMrK4Os7H8Wlv9/gR74g3AxktMhJIOU1L+DBwECiPH169dCQkL/gYABDHEDJiam69evAwQQy79//yB8sN9xAogsUDFAAIE0QDgENQDBnz9/AAIIagNcDwQwMjIyoAAgFyoLEEAgDS9evPgDBv/AAGIShA1iMIAgkAH0A1AKIMAA5a1fe6Xb4q0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ../~/@master/webinfra-frontend-components/style/images/flag-icons/mc.png
// module id = 1286
// module chunks = 0